import React, { useState } from "react";
import { TextField, Alert } from "@mui/material";
import { Delete } from "@mui/icons-material";
import apiUrl from "../api";

import axios from "axios";

const DeleteGroup = ({ property }) => {
  const [propertyName, setPropertyName] = useState(property.name);
  const [popUpOpen, setPopUpOpen] = useState(false);
  const [buttonWidth, setButtonWidth] = useState(
    window.innerWidth <= 768 ? "100%" : "auto"
  );

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const user = JSON.parse(localStorage.getItem("user"));

  const handleDeleteProperty = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    // Delete your API call here to delete the property
    try {
      const response = await axios.put(
        `${apiUrl}/group/deleteGroup/${property._id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );

      setSuccess("Property deleted successfully.");
    } catch (error) {
      if (error.response && error.response.status === 409) {
        setError("Property already exists.");
      } else {
        setError("Failed to delete property. Please try again.");
      }
    }
  };

  return (
    <>
      <div className="delete-property-option-wrapper">
        {error && <Alert severity="error">{error}</Alert>}
        {success && <Alert severity="success">{success}</Alert>}
        <h4
          style={{
            marginBottom: "0px",

            fontWeight: "600",
          }}
        >
          {property.name}
        </h4>

        <h5>Are you sure you want to delete this group?</h5>

        <button
          className="add-ticket-button__button"
          sx={{
            backgroundColor: "var(--primary-color)",
            color: "var(--primary-text-color)",
            fontSize: "15px",
            fontWeight: "600",
            width: "auto",
            padding: "10px 20px",
          }}
          onClick={handleDeleteProperty}
        >
          Yes
          <Delete />
        </button>
      </div>
    </>
  );
};

export default DeleteGroup;
